<template>
  <output
    class="toast-container d-flex align-center justify-center rounded-lg"
    :class="containerClasses"
    :style="containerStyle"
    aria-live="polite"
  >
    <div class="toast-content d-flex flex-column justify-space-between">
      <slot />
    </div>
  </output>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  width?: number | string
  height?: number | string
  variant?: 'dark' | 'error'
}>()

const containerClasses = computed(() => {
  return {
    '--dark': props.variant === 'dark',
    '--error': props.variant === 'error',
  }
})

const containerStyle = computed(() => {
  const toCssSize = (v?: number | string) => {
    if (v === undefined || v === null) return undefined
    return typeof v === 'number' ? `${v}px` : v
  }
  return {
    width: toCssSize(props.width),
    height: toCssSize(props.height),
  }
})
</script>

<style scoped lang="scss">
@import "@/scss/box-shadow-tokens";

.toast-container {
  position: fixed;
  bottom: 40px;
  right: 34px;
  display: block;
  @include box-shadow('box-shadow-medium');
}

.toast-content {
  padding: 18px;
  width: 100%;
  height: 100%;
}

.toast-container.--dark {
  background-color: rgb(var(--v-theme-grey-900));
  color: rgb(var(--v-theme-white));
}

.toast-container.--error {
  background-color: rgb(var(--v-theme-error-darken-1));
}
</style>
